import React from 'react';
import { generatePath, useHistory } from 'react-router';

import { UploadImage } from 'src/modules/homeownerApp/components/UploadImage';
import { useProPageContext } from 'src/modules/pro/hooks/useProPageContext';
import { type AiOriginalImage } from 'src/shared/graphql/generated';
import { Route } from 'src/shared/route';

const PhotoLabelSheet = () => {
  const history = useHistory();
  const handleImageStatusDone = ({ image }: { image: AiOriginalImage }) => {
    history.push(
      generatePath(Route.HOMEOWNER_APP_ORIGINAL.path, {
        aiOriginalImageId: image.id,
      }),
      { from: 'upload' },
    );
  };
  const {
    leadData,
    setImageFileToUpload,
    imageFileToUpload,
    orgId,
    orgDisplayName,
  } = useProPageContext();
  const { email } = leadData || {};

  return (
    <UploadImage
      email={email}
      fromLLP
      handleImageStatusDone={handleImageStatusDone}
      imageFileToUpload={imageFileToUpload}
      orgDisplayName={orgDisplayName}
      orgId={orgId}
      setImageFileToUpload={setImageFileToUpload}
    />
  );
};

export { PhotoLabelSheet };
